import { atomWithSessionStorage } from '@libs/data-access/queries'
import { useAtom } from 'jotai'

export type FunnelElecSignature = {
  title: string
  document_id: number
  membership_id: number | null
  is_on_page?: boolean
}

const funnelElecSignatureAtom =
  atomWithSessionStorage<FunnelElecSignature | null>(
    'store-e-signature-attachment-already-imported',
    null
  )

export const useStoreFunnelElectronicSignature = () => {
  const [data, setData] = useAtom(funnelElecSignatureAtom)
  const storeData = (data: FunnelElecSignature) => {
    setData({
      ...data
    })
  }
  const revokeData = () => {
    setData(null)
  }

  return {
    data,
    storeData,
    revokeData
  }
}
